import { Navigate } from 'react-router-dom';

/**
 * `/settings` is a tabbed page; the default tab is "general". This component
 * exists only as the redirect target so old links still land on something.
 */
export function Settings() {
  return <Navigate to="/settings/general" replace />;
}
